import {useEffect, useRef, useState} from 'react';
import * as utils from '../lib/Utils';
import {debounce} from 'lodash';


export function useDebouncedEffect(callback, delay, deps = []) {

    const debouncedCallback = debounce(callback,delay);

    useEffect(()=>{
            //console.log('Trying bounced effect: '+ _.now());
            debouncedCallback();
            return debouncedCallback.cancel;
        },
        [delay, ...deps],
    );
}


// Sets up derived object that maintains the same object if the sources properties have the same value.
// Prevents unneeded (and sometimes troublesome) re-renders if passing the derived object as a property.
export function useDerivedObject(source, deriveFunc, initialValue)
{
    const ref = useRef(initialValue);
    ref.current = utils.objectReplaceReducer(ref.current, deriveFunc(source));

    return ref.current;
}
